/* Advertorial — Sticky CTA, Attributions-Weitergabe, Custom Events für Meta/GA4. */
(function () {
  'use strict';

  /* Reveal-Styles erst freischalten, wenn JS läuft — sonst bliebe Inhalt unsichtbar. */
  document.documentElement.classList.add('adv-js');

  var cfg = window.advertorial || {};
  var hero = document.querySelector('[data-adv-hero]');
  var variant = (hero && hero.getAttribute('data-adv-variant')) || 'v1';

  /* Shopify.analytics steht erst nach dem Laden von trekkie bereit.
     Events werden bis dahin gepuffert, damit advertorial_view nicht verloren geht. */
  var queue = [];
  var flushTries = 0;

  function ready() {
    return !!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function');
  }

  function flush() {
    if (!ready()) {
      if (flushTries++ < 40) setTimeout(flush, 250);
      return;
    }
    while (queue.length) {
      var item = queue.shift();
      try {
        Shopify.analytics.publish(item[0], item[1]);
      } catch (e) {
        /* Tracking darf die Seite nie brechen */
      }
    }
  }

  function publish(name, extra) {
    var payload = {
      handle: cfg.handle || document.location.pathname,
      variant: variant,
      path: document.location.pathname
    };
    if (extra) {
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k];
      }
    }
    queue.push([name, payload]);
    flush();
  }

  /* ── 1. Attribution: fbclid / utm_* an jeden CTA hängen ── */
  var search = document.location.search;
  if (search && search.length > 1) {
    var incoming = new URLSearchParams(search);
    var keep = new URLSearchParams();
    incoming.forEach(function (value, key) {
      if (key === 'fbclid' || key === 'gclid' || key === 'ttclid' || key.indexOf('utm_') === 0) {
        keep.append(key, value);
      }
    });
    var extraQuery = keep.toString();
    if (extraQuery) {
      document.querySelectorAll('a[data-adv-cta]').forEach(function (link) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) === '#') return;
        try {
          var url = new URL(href, document.location.origin);
          if (url.origin !== document.location.origin) return;
          keep.forEach(function (value, key) {
            if (!url.searchParams.has(key)) url.searchParams.append(key, value);
          });
          link.setAttribute('href', url.pathname + url.search + url.hash);
        } catch (e) {
          /* ungültige URL — Link unverändert lassen */
        }
      });
    }
  }

  /* ── 2. CTA-Klicks ── */
  document.querySelectorAll('a[data-adv-cta]').forEach(function (link) {
    link.addEventListener('click', function () {
      publish('advertorial_cta_click', {
        position: link.getAttribute('data-adv-cta'),
        destination: link.getAttribute('href')
      });
    });
  });

  /* ── 3. Reveal-Animation ── */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05 }
    );
    document.querySelectorAll('.adv-reveal').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    revealAll();
  }

  function revealAll() {
    document.querySelectorAll('.adv-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* Sicherheitsnetz: falls der Observer nie feuert (Prerender, exotische Browser),
     darf kein Inhalt unsichtbar bleiben. */
  setTimeout(revealAll, 2500);

  /* ── 4. Scroll-Tiefe ── */
  var marks = [25, 50, 75, 100];
  var fired = {};
  var ticking = false;

  function measure() {
    ticking = false;
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return;
    var percent = ((window.scrollY || doc.scrollTop) / scrollable) * 100;
    for (var i = 0; i < marks.length; i++) {
      var mark = marks[i];
      if (percent >= mark && !fired[mark]) {
        fired[mark] = true;
        publish('advertorial_scroll', { percent: mark });
      }
    }
    if (fired[100]) window.removeEventListener('scroll', onScroll);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(measure);
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  /* ── 5. Artikelende erreicht ── */
  var end = document.querySelector('[data-adv-end]');
  if (end && 'IntersectionObserver' in window) {
    var endObserver = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          publish('advertorial_read_complete', {});
          endObserver.disconnect();
        }
      },
      { threshold: 0 }
    );
    endObserver.observe(end);
  }

  /* ── 6. Seitenaufruf ── */
  publish('advertorial_view', {});
})();
